import { IonicPageModule } from 'ionic-angular';
import { NgModule } from '@angular/core';

import { TrucksPage } from './trucks';

@NgModule({
  declarations: [TrucksPage],
  imports: [IonicPageModule.forChild(TrucksPage)],
})
export class TrucksPageModule {}



// WEBPACK FOOTER //
// ./src/pages/trucks/trucks.module.ts